import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3a18cb25")

_pushScopeId("data-v-3a18cb25")
const _hoisted_1 = { class: "kn-remove-card-padding p-col" }
const _hoisted_2 = { class: "kn-list-item" }
const _hoisted_3 = { class: "kn-list-item-text" }
const _hoisted_4 = { class: "kn-truncated" }
const _hoisted_5 = { class: "p-fluid p-formgrid p-grid p-m-2" }
const _hoisted_6 = { class: "p-field p-col-12 p-mt-2" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = {
  for: "title",
  class: "kn-material-input-label"
}
const _hoisted_9 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_10 = { class: "p-float-label " }
const _hoisted_11 = {
  for: "driver",
  class: "kn-material-input-label"
}
const _hoisted_12 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = {
  for: "operator",
  class: "kn-material-input-label"
}
const _hoisted_15 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_16 = { class: "p-float-label" }
const _hoisted_17 = {
  for: "title",
  class: "kn-material-input-label"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_InlineMessage = _resolveComponent("InlineMessage")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--default" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.drivers.visibilityTitle')), 1)
        ]),
        end: _withId(() => [
          _createVNode(_component_Button, {
            label: _ctx.$t('managers.businessModelManager.addCondition'),
            class: "p-button-text p-button-rounded p-button-plain kn-white-color",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openVisibilityConditionDialog('newCondition')))
          }, null, 8, ["label"])
        ]),
        _: 1
      }),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Listbox, {
        class: "kn-list data-condition-list",
        options: _ctx.visusalDependencyObjects,
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openVisibilityConditionDialog($event.value)))
      }, {
        empty: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.drivers.noVisCond')), 1)
        ]),
        option: _withId((slotProps) => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _withDirectives(_createVNode("span", _hoisted_4, [
                _createVNode("b", null, _toDisplayString(slotProps.option.viewLabel), 1),
                _createTextVNode(" " + _toDisplayString(slotProps.option.parFatherUrlName) + " " + _toDisplayString(slotProps.option.operation) + _toDisplayString(slotProps.option.compareValue), 1)
              ], 512), [
                [
                  _directive_tooltip,
                  slotProps.option.viewLabel + ' ' + slotProps.option.parFatherUrlName + ' ' + slotProps.option.operation + slotProps.option.compareValue,
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _createVNode(_component_Button, {
              icon: "far fa-trash-alt",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _withModifiers(($event: any) => (_ctx.deleteCondition(slotProps.option)), ["stop"])
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["options"])
    ]),
    _createVNode(_component_Dialog, {
      class: "remove-padding",
      style: _ctx.driversDescriptor.style.conditionDialog,
      visible: _ctx.showVisibilityConditionDialog,
      modal: true,
      closable: false
    }, {
      header: _withId(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary kn-width-full" }, {
          start: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.drivers.visualizationTitle')), 1)
          ]),
          _: 1
        })
      ]),
      footer: _withId(() => [
        _createVNode(_component_Button, {
          class: "p-button-text kn-button",
          label: _ctx.$t('common.cancel'),
          onClick: _cache[11] || (_cache[11] = ($event: any) => {;(_ctx.showVisibilityConditionDialog = false), (_ctx.selectedCondition = {})})
        }, null, 8, ["label"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          label: _ctx.$t('common.save'),
          disabled: _ctx.v$.$invalid,
          onClick: _ctx.saveCondition
        }, null, 8, ["label", "disabled", "onClick"])
      ]),
      default: _withId(() => [
        _createVNode(_component_InlineMessage, {
          severity: "info",
          class: "p-m-2 kn-width-full"
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.drivers.visualizationHint')), 1)
          ]),
          _: 1
        }),
        _createVNode("form", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("span", _hoisted_7, [
              _createVNode(_component_InputText, {
                id: "title",
                class: ["kn-material-input", { 'p-invalid': _ctx.v$.selectedCondition.viewLabel.$invalid && _ctx.v$.selectedCondition.viewLabel.$dirty }],
                modelValue: _ctx.v$.selectedCondition.viewLabel.$model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.selectedCondition.viewLabel.$model = $event)),
                onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.selectedCondition.viewLabel.$touch()))
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('common.title')) + " *", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.selectedCondition.viewLabel,
              additionalTranslateParams: { fieldName: _ctx.$t('common.title') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("span", _hoisted_10, [
              _createVNode(_component_Dropdown, {
                id: "driver",
                class: ["kn-material-input", { 'p-invalid': _ctx.v$.selectedCondition.parFatherId.$invalid && _ctx.v$.selectedCondition.parFatherId.$dirty }],
                modelValue: _ctx.v$.selectedCondition.parFatherId.$model,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.selectedCondition.parFatherId.$model = $event)),
                options: _ctx.availableDrivers,
                optionLabel: "label",
                optionValue: "id",
                onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.selectedCondition.parFatherId.$touch())),
                onChange: _ctx.setParFatherUrlName
              }, null, 8, ["modelValue", "options", "class", "onChange"]),
              _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('managers.businessModelManager.analyticalDriver')) + " *", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.selectedCondition.parFatherId,
              additionalTranslateParams: { fieldName: _ctx.$t('managers.businessModelManager.analyticalDriver') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("span", _hoisted_13, [
              _createVNode(_component_Dropdown, {
                id: "operator",
                class: ["kn-material-input", { 'p-invalid': _ctx.v$.selectedCondition.operation.$invalid && _ctx.v$.selectedCondition.operation.$dirty }],
                modelValue: _ctx.v$.selectedCondition.operation.$model,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.selectedCondition.operation.$model = $event)),
                options: _ctx.availableOperators,
                onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.selectedCondition.operation.$touch()))
              }, null, 8, ["modelValue", "options", "class"]),
              _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('managers.businessModelManager.filterOperator')) + " *", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.selectedCondition.operation,
              additionalTranslateParams: { fieldName: _ctx.$t('managers.businessModelManager.filterOperator') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("span", _hoisted_16, [
              _createVNode(_component_InputText, {
                id: "title",
                class: ["kn-material-input", { 'p-invalid': _ctx.v$.selectedCondition.compareValue.$invalid && _ctx.v$.selectedCondition.compareValue.$dirty }],
                modelValue: _ctx.v$.selectedCondition.compareValue.$model,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.selectedCondition.compareValue.$model = $event)),
                onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.selectedCondition.compareValue.$touch()))
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('common.value')) + " *", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.selectedCondition.compareValue,
              additionalTranslateParams: { fieldName: _ctx.$t('common.value') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["style", "visible"])
  ], 64))
})